/**
 * Il logo 3D con il suo caricamento differito già dentro.
 *
 * `three` pesa più del bundle iniziale di tutta l'app: deve stare in un chunk a parte, preso
 * solo da chi vede davvero il logo e solo dopo che la pagina è disegnata. Questo file esiste
 * perché quel `lazy` + `Suspense` era destinato a essere ricopiato in ogni punto che monta il
 * marchio — login, sidebar, menu mobile — e tre copie divergono.
 *
 * Il `fallback` copre **due** momenti diversi con lo stesso disegno: mentre il chunk arriva, e
 * per sempre se il dispositivo non ha WebGL. Sono la stessa prop apposta: se fossero due, prima
 * o poi mostrerebbero due cose diverse.
 */
import { lazy, Suspense, type ReactNode } from 'react';
import type { MaewayLogo3DProps } from './MaewayLogo3D';

const MaewayLogo3D = lazy(() => import('./MaewayLogo3D'));

export interface MaewayLogoLazyProps extends Omit<MaewayLogo3DProps, 'fallback'> {
  /** Il marchio statico: si vede mentre il chunk si scarica e al posto del 3D senza WebGL. */
  fallback: ReactNode;
}

export function MaewayLogoLazy({ fallback, ...props }: MaewayLogoLazyProps) {
  return (
    <Suspense fallback={fallback}>
      <MaewayLogo3D fallback={fallback} {...props} />
    </Suspense>
  );
}
